import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav0").addClass("active");
var banner = new Swiper('.index-banner .swiper-container', {
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed:500,
    effect: 'fade',
    loop:true,//必须
    
    on: {
      init: function (swiper) { 
          this.emit('transitionEnd');
      },
      transitionEnd: function () {

      }
    }
});
// 企业介绍
var about1 = new Swiper('.section1 .swiper1', {
    loop:true,
    navigation: {
      nextEl: '.section1 .swiper-button-next',
      prevEl: '.section1 .swiper-button-prev',
    },
});
  var about2 = new Swiper('.section1 .swiper2', {
    loop:true,
    initialSlide:1,
    navigation: {
      nextEl: '.section1 .swiper-button-next',
      prevEl: '.section1 .swiper-button-prev',
    },
});
//合作伙伴
var swiper = new Swiper(".section4 .mySwiper", {
  slidesPerView: 6,
  spaceBetween: 10,
  slidesPerGroup: 6,
  speed:500,
  loop:true,
  pagination: {
    el: ".section4 .swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  breakpoints: {
    320: { //当屏幕宽度大于等于320
      slidesPerView: 2,
      spaceBetween: 10,
      slidesPerGroup: 2,
    },
    768: { //当屏幕宽度大于等于768 
      slidesPerView: 3,
      spaceBetween: 10,
      slidesPerGroup: 3,
    },
    1280: { //当屏幕宽度大于等于1280
      slidesPerView: 4,
      spaceBetween: 10,
      slidesPerGroup: 4,
    },
    1600: { //当屏幕宽度大于等于1280
      slidesPerView: 6,
      spaceBetween: 10,
      slidesPerGroup: 6,
    }
},
});

//新闻板块
$(".news-nav a").eq(0).addClass("active")
$(".section3 .pic div").eq(0).addClass("active")
$(".news-content ul").eq(0).addClass("active")
$(".section3 .pic div img:first-child").addClass("active")
$(".news-nav a").hover(function () {
    let index = $(this).index()
    $(this).addClass("active").siblings().removeClass("active");
    $(".section3 .pic div").eq(index).addClass("active").siblings().removeClass("active");
    $(".news-content ul").eq(index).addClass("active").siblings().removeClass("active");
})
$(".news-content ul li").hover(function () {
    let index = $(this).index()
    let index1 = $(this).parent().index()
    $(this).addClass("active").siblings().removeClass("active");
    $(".section3 .pic div").eq(index1).find('img').eq(index).addClass("active").siblings().removeClass("active");
})